import { render, staticRenderFns } from "./AdvertConfig.vue?vue&type=template&id=5f6066ce&scoped=true"
import script from "./AdvertConfig.vue?vue&type=script&lang=js"
export * from "./AdvertConfig.vue?vue&type=script&lang=js"
import style0 from "./AdvertConfig.vue?vue&type=style&index=0&id=5f6066ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6066ce",
  null
  
)

export default component.exports